module.exports = __webpack_public_path__ + "media/hero-home.368ef914.mp4";